import React from "react";

import {
  HistoryRounded,
  MenuRounded,
  MoreVertRounded,
  NotificationAddRounded,
} from "@mui/icons-material";
import { Box, ListItemIcon, Menu, MenuItem } from "@mui/material";

import useMainState from "../../../config/context/mainStateContext";

import MainNotificationManager from "../../../components/MainNotificationManager";
import MainText from "../../../components/MainText";
import PageHeader from "../../../components/PageHeader";
import { Constants } from "../../../config/constants";
import ModalHistory from "./ModalHistory";
import ModalNotificationCreate from "./ModalNotificationCreate";

// import TimeAgo from "react-timeago";
// import buildFormatter from "react-timeago/lib/formatters/buildFormatter";
// import portStrings from "react-timeago/lib/language-strings/pt-br";
// const formatter = buildFormatter(portStrings);
// <TimeAgo date={new Date(1702041320331)} formatter={formatter} />)

export default function AdminNotificationPage() {
  const { setShowSideMenuDrawer } = useMainState();

  const [anchorMenu, setAnchorMenu] = React.useState<null | HTMLElement>(null);
  const openMenu = Boolean(anchorMenu);

  const [openModalHistory, setOpenModalHistory] = React.useState(false);
  const [openModalCreate, setOpenModalCreate] = React.useState(false);

  const handleClickMenu = (event?: React.MouseEvent<HTMLButtonElement>) => {
    if (event) setAnchorMenu(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorMenu(null);
  };

  return (
    <Box
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
      }}
      pt={"30px"}
      pb={"45px"}
    >
      <Box width={"90%"}>
        <PageHeader
          title="Notificações"
          leftIcon={<MenuRounded />}
          onLeftAction={() => setShowSideMenuDrawer(true)}
          rightIcon={<MoreVertRounded />}
          onRightAction={handleClickMenu}
        />

        {/* Menu More */}

        <Menu
          id="basic-menu"
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorEl={anchorMenu}
          open={openMenu}
          onClose={handleCloseMenu}
          MenuListProps={{ "aria-labelledby": "basic-button" }}
        >
          <Box sx={{ minWidth: "40vw", maxWidth: "60vw" }}>
            <MenuItem onClick={() => setOpenModalCreate(true)}>
              <ListItemIcon>
                <NotificationAddRounded fontSize="small" />
              </ListItemIcon>
              Criar
            </MenuItem>
            <MenuItem
              onClick={() => {
                setOpenModalHistory(true);
                handleCloseMenu();
              }}
            >
              <ListItemIcon>
                <HistoryRounded fontSize="small" />
              </ListItemIcon>
              Histórico
            </MenuItem>
          </Box>
        </Menu>

        {/* Create */}

        {openModalCreate && (
          <ModalNotificationCreate
            onClose={() => {
              setOpenModalCreate(false);
              handleCloseMenu();
            }}
          />
        )}

        {/* History */}

        {openModalHistory && (
          <ModalHistory
            onClose={() => {
              setOpenModalHistory(false);
              handleCloseMenu();
            }}
          />
        )}

        {/* Channels */}

        <Box mt={4}>
          <Box mb={2}>
            <MainText size="subtitle" color="black">
              Canais
            </MainText>
          </Box>

          <MainNotificationManager topicsToManage={Constants.privateTopics} />
        </Box>
      </Box>
    </Box>
  );
}
